<template>
  <div class="actions-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ActionsWrapper',
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.actions-wrapper {
  border-top: 1px solid ds-variables.$grey-300;
  padding: 12px;
}
</style>
